import { useState, useEffect } from 'react';

import { cfetch } from '@confluence/network';

export const useLoadVideoDurations = (videos) => {
	const [videoDurations, setVideoDurations] = useState({});
	const [isLoadingDurations, setIsLoadingDurations] = useState(false);

	const getLoomVideoDuration = async (videoId: string): Promise<number> => {
		try {
			if (!videoId) return 0;

			const apiUrl = `https://www.loom.com/v1/videos/${videoId}`;

			const response = await cfetch(apiUrl, {
				credentials: 'omit',
				headers: {
					Accept: 'application/json',
				},
			});

			if (!response.ok) return 0;

			const data = await response.json();

			return data.video_properties.durationMs || 0;
		} catch {
			return 0;
		}
	};

	useEffect(() => {
		const loadDurations = async () => {
			setIsLoadingDurations(true);
			const durations = {};
			if (videos?.length) {
				await Promise.all(
					videos.map(async ({ id }) => {
						durations[id] = await getLoomVideoDuration(id);
					}),
				);
			}
			setVideoDurations(durations);
			setIsLoadingDurations(false);
		};
		if (videos?.length) {
			void loadDurations();
		}
	}, [videos]);
	return { videoDurations, isLoadingDurations };
};
